import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const inputRef = useRef(null);
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        boardMasterId: '',
        streamOrMediumMasterId: '',
        sectionName: '',
        address: '',
        state: '',
        district: '',
        city: '',
        pincode: '',
        sectionInchargeName: '',
        contactNumber: '',
        contactNumber2: '',
        allottedStudents: '',
        isActive: true,
        email: '',
        website: '',
        logoName: '',
        logoPath: ''
    }
    const [boardData, setBoardData] = useState([])
    const [streamData, setStreamData] = useState([])
    const [sectionData, setSectionData] = useState(initialFormState)
    const [sectionList, setSectionList] = useState([])
    const [editId, setEditId] = useState(null)
    const [StateList, setStateList] = useState([])
    const [CityList, setCityList] = useState([])
    const [DistList, setDistList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [sectionIdSort, setSectionIdSort] = useState(null);
    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [principleNameSort, setPrincipleNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["boardMasterDetails.boardName", "streamOrMediumMasterDetails.streamName", "sectionId", "sectionName", "sectionInchargeName", "email", "website"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getBoard();
        getSectionList();
        getStateList()
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getSectionList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setSectionList(await searchArray("I", `/get-section?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(sectionList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(sectionList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > sectionList.length) {
            endIndex = sectionList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(sectionList.slice(startIndex, endIndex));
    }, [sectionList, currPage, itemsPerPage]);

    const getBoard = () => {
        const apiUrl = `institute-wise-board-stream?instituteId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setBoardData(response.data.boards)
                setStreamData(response.data.streams)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getStateList = () => {
        const apiUrlForInstitute = `/all-states`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setStateList(response.data.result.map((board) => {
                    return {
                        value: board.id,
                        label: board.stateName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getSectionList = async () => {
        try {
            const apiUrlForSection = `/get-section?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrlForSection);
            setSectionList(response.data.result)
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSectionData((prevData) => {
            if (type === 'checkbox') {
                return {
                    ...prevData,
                    [name]: checked,
                };
            } else if (name === 'contactNumber' || name === 'contactNumber2') {
                // Filter out non-numeric characters and limit to 10 digits
                const filteredValue = value.replace(/[^0-9]/g, '').slice(0, 10);
                return {
                    ...prevData,
                    [name]: filteredValue,
                };
            } else {
                return {
                    ...prevData,
                    [name]: value,
                };
            }
        })
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            setSectionData((prevData) => {
                return {
                    ...prevData,
                    logoPath: '',
                    logoName: ''
                }
            })
            return;
        }

        let fileExtention = file.name.split(".").pop()
        const allowedExtensions = ["jpeg", "jpg", "png", "webp", "svg", "JPEG", "JPG", "PNG", "WEBP", "SVG"];

        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtention)) {
            setLoading(true);
            const apiUrl = "uploadimage";
            authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                .then((res) => {
                    setSectionData((prevData) => {
                        if (e.target.name === 'logoName' && file) {
                            return {
                                ...prevData,
                                logoPath: res.data.result,
                                logoName: file.name,
                            }
                        }
                    })
                })
                .catch((err) => {
                    const errorMsg = err?.response?.data?.error || "Something went wrong!";
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            e.target.value = '';
            Swal.fire({ text: "Only JPEG, PNG, WEBP, and SVG files are supported" });
        }
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const mandatoryFields = Object.keys(sectionData).filter(field => !['address', 'state', 'district', 'city', 'pincode', 'contactNumber2', 'website', 'logoName', 'logoPath'].includes(field));
        const contactNumberValid = sectionData.contactNumber.length == 10;
        const contactNumber2Valid = !sectionData.contactNumber2 || sectionData.contactNumber2.length == 10;
        const contactNumberNotSame = sectionData.contactNumber !== sectionData.contactNumber2;
        return Object.values(error).every((error) => error === '') &&
            mandatoryFields.every((field) => typeof sectionData[field] === "string" ? sectionData[field] !== '' : sectionData[field]?.length !== 0) && contactNumberValid && contactNumber2Valid && contactNumberNotSame;
    };

    const validateFalse = () => {
        for (const [key, value] of Object.entries(sectionData)) {
            if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'contactNumber2' && key !== 'website' && key !== 'logoName' && key !== 'logoPath') {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        emailRegex.test(sectionData.email) ?
            setError((prevData) => {
                return {
                    ...prevData,
                    email: '',
                }
            })
            : setError((prevData) => {
                return {
                    ...prevData,
                    email: 'Enter valid Email ID',
                }
            })

        if (sectionData.contactNumber.length > 0 && sectionData.contactNumber.length < 10) {
            setError((prevData) => ({
                ...prevData,
                contactNumber: 'Contact number must be at least 10 characters long.',
            }));
        }

        if (sectionData.contactNumber2 && sectionData.contactNumber2.length > 0 && sectionData.contactNumber2.length < 10) {
            setError((prevData) => ({
                ...prevData,
                contactNumber2: 'Contact number 2 must be at least 10 characters long.',
            }));
        }

        if (sectionData.contactNumber2 && sectionData.contactNumber && sectionData.contactNumber.length > 0 && sectionData.contactNumber2.length > 0 && sectionData.contactNumber === sectionData.contactNumber2) {
            setError((prevData) => ({
                ...prevData,
                contactNumber: "Contact number 1 & contact number 2 will not be same.",
                contactNumber2: "Contact number 1 & contact number 2 will not be same.",
            }));
        }
    }

    const checking = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(sectionData.email)
    }

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(sectionData)) {
                if (key !== 'address' && key !== 'state' && key !== 'district' && key !== 'city' && key !== 'pincode' && key !== 'contactNumber2' && key !== 'website' && key !== 'logoName' && key !== 'logoPath') {
                    if (value == '' || value.length == 0) {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.',
                            }
                        })
                    } else if (value.length !== 0 && value !== '' && error[key]?.length !== 0 && error[key] !== '') {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: '',
                            }
                        })
                    }
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            emailRegex.test(sectionData.email) ?
                setError((prevData) => {
                    return {
                        ...prevData,
                        email: '',
                    }
                })
                : setError((prevData) => {
                    return {
                        ...prevData,
                        email: 'Enter valid Email ID',
                    }
                })

            if (sectionData.contactNumber && sectionData.contactNumber.length > 0 && sectionData.contactNumber.length < 10) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'Contact number must be at least 10 characters long.',
                }));
            } else if (sectionData.contactNumber == '' || sectionData.contactNumber == 0) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: 'This field is required.',
                }));
            } else {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber: '',
                }));
            }

            if (sectionData.contactNumber2 && sectionData.contactNumber2.length > 0 && sectionData.contactNumber2.length < 10) {
                setError((prevData) => ({
                    ...prevData,
                    contactNumber2: 'Contact number 2 must be at least 10 characters long.',
                }));
            } else {
                setError((prevData) => {
                    const { contactNumber2, ...rest } = prevData;
                    return rest;
                });
            }
        }
    }, [sectionData])

    const addSection = async () => {
        if (validateForm() && checking()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section`;
                const response = await authorizedAxiosInstitute.post(apiUrl, sectionData);
                await getSectionList();
                setSectionData(initialFormState);
                setSaveId(response.data.createdSection.id);
                setBoardSort(null);
                setMediumSort(null);
                setSectionIdSort(null);
                setSectionNameSort(null);
                setPrincipleNameSort(null);
                setEmailSort(null);
                setSearchValue(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            validateFalse();
        }
    }

    const deleteSection = async (id) => {
        const confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (!confirmed) return;

        setLoading(true);

        try {
            const apiUrl = `/delete-section?id=${id}`;
            const response = await authorizedAxiosInstitute?.delete(apiUrl);

            const page = deleteItem(currPage, itemsPerPage, sectionList.length);
            await getSectionList();
            setCurrPage(page);

            Swal.fire({ text: response.data.message });

        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            Swal.fire({
                title: errorMsg,
                text: 'Do you want to delete forcefully?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showLoaderOnConfirm: true,
                preConfirm: async () => {
                    try {
                        const { isConfirmed } = await Swal.fire({
                            html: `
                                <div>
                                    <p>Enter Administrative Password:</p>
                                    <input type="password" id="swal-input" class="swal2-input" placeholder="Password">
                                </div>
                            `,
                            showCancelButton: true,
                            confirmButtonText: 'Submit',
                        });

                        if (!isConfirmed) return;

                        const inputValue = document.getElementById('swal-input').value;
                        const confirmAPIurl = `/force-delete-section?id=${id}&password=${inputValue}`;
                        const forceDeleteResponse = await authorizedAxiosInstitute?.delete(confirmAPIurl);

                        const page = deleteItem(currPage, itemsPerPage, sectionList.length);
                        await getSectionList();
                        setCurrPage(page);

                        Swal.fire({ text: forceDeleteResponse.data.message });

                    } catch (forceDeleteError) {
                        const forceDeleteErrorMsg = forceDeleteError?.response?.data?.message || 'Something went wrong!';
                        Swal.fire({ text: forceDeleteErrorMsg });
                    }
                }
            });

        } finally {
            setLoading(false);
        }
    };


    const updateSection = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/edit-section?id=${editId}`;
                const response = await authorizedAxiosInstitute.put(apiUrl, sectionData);
                await getSectionList();
                setEditId(null);
                setSectionData(initialFormState)
                inputRef.current.value = "";
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            validateFalse();
        }
    }

    const handleChangeState = (selectedOptions) => {
        setSectionData((prevData) => {
            return {
                ...prevData,
                state: selectedOptions.label,
                district: ''
            }
        })

        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleEditChangeState = (selectedOptions) => {
        const apiUrlForInstitute = `/state-wise-district-city?id=${selectedOptions.value}`;
        authorizedAxios && authorizedAxios.get(apiUrlForInstitute)
            .then(response => {
                setCityList(response.data.cities.map((board) => {
                    return {
                        value: board.id,
                        label: board.cityName
                    }
                }))
                setDistList(response.data.districts.map((board) => {
                    return {
                        value: board.id,
                        label: board.districtName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (editId !== null && editId !== "" && sectionData.district !== "") {
            handleEditChangeState(sectionData.state == '' ? null : StateList.filter(option =>
                sectionData.state && sectionData.state == option.label && (option.value)
            )[0]);
        }
    }, [editId]);

    const handleChangeDist = (selectedOptions) => {
        setSectionData((prevData) => {
            return {
                ...prevData,
                district: selectedOptions.label,
            }
        })
    }

    const handleChangeCity = (selectedOptions) => {
        setSectionData((prevData) => {
            return {
                ...prevData,
                city: selectedOptions.label,
            }
        })
    }

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setMediumSort(null);
            setSectionIdSort(null);
            setSectionNameSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setBoardSort(null);
            setSectionIdSort(null);
            setSectionNameSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (sectionIdSort == true || sectionIdSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSectionNameSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [sectionIdSort])

    useEffect(() => {
        if (sectionNameSort == true || sectionNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSectionIdSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [sectionNameSort])

    useEffect(() => {
        if (principleNameSort == true || principleNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSectionIdSort(null);
            setSectionNameSort(null);
            setEmailSort(null);
        }
    }, [principleNameSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSectionIdSort(null);
            setSectionNameSort(null);
            setPrincipleNameSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <div id='scroll-up'></div>
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Section Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-building-columns"></i>Section Master</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" aria-label="Default select example" name='boardMasterId' onChange={handleInputChange} value={sectionData.boardMasterId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            boardData?.map((board) => {
                                                                return <option value={board.boardMasterDetails.id}>{board.boardMasterDetails.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.boardMasterId && <p style={{ color: 'red' }}>{error.boardMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" aria-label="Default select example" name='streamOrMediumMasterId' onChange={handleInputChange} value={sectionData.streamOrMediumMasterId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            streamData?.map((stream) => {
                                                                return <option value={stream.streamOrMediumMasterDetails.id}>{stream.streamOrMediumMasterDetails.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.streamOrMediumMasterId && <p style={{ color: 'red' }}>{error.streamOrMediumMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Enter Section Name :</label>
                                                    <input type="text" className="form-control" name="sectionName" value={sectionData.sectionName} onChange={handleInputChange} />
                                                    {error.sectionName && <p style={{ color: 'red' }}>{error.sectionName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Principle Name :</label>
                                                    <input type="text" className="form-control" name="sectionInchargeName" value={sectionData.sectionInchargeName} onChange={handleInputChange} />
                                                    {error.sectionInchargeName && <p style={{ color: 'red' }}>{error.sectionInchargeName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Address :</label>
                                                    <input type="text" className="form-control" name="address" value={sectionData.address} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">State :</label>
                                                    <Select
                                                        value={sectionData.state == '' ? null : StateList.filter(option =>
                                                            sectionData.state && sectionData.state == option.label && (option.value)
                                                        )[0]}
                                                        name="state"
                                                        options={StateList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeState}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">District :</label>
                                                    <Select
                                                        value={sectionData.district == '' ? null : DistList.filter(option =>
                                                            sectionData.district && sectionData.district == option.label && (option.value)
                                                        )[0]}
                                                        name="district"
                                                        options={DistList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeDist}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">City :</label>
                                                    <input type="text" className="form-control" name="city" value={sectionData.city} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Pincode :</label>
                                                    <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="pincode" value={sectionData.pincode} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Contact Number :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber" value={sectionData.contactNumber} onChange={handleInputChange} />
                                                    {error.contactNumber && <p style={{ color: 'red' }}>{error.contactNumber}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Contact Number II :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="contactNumber2" value={sectionData.contactNumber2} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Email-Id :</label>
                                                    <input type="email" className="form-control" disabled={editId} name="email" value={sectionData.email} onChange={handleInputChange} />
                                                    {error.email && <p style={{ color: 'red' }}>{error.email}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Website :</label>
                                                    <input type="text" className="form-control" name="website" value={sectionData.website} onChange={handleInputChange} />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>No. of Alloted Students :</label>
                                                    <input type="number" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control" name="allottedStudents" value={sectionData.allottedStudents} onChange={handleInputChange} />
                                                    {error.allottedStudents && <p style={{ color: 'red' }}>{error.allottedStudents}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="logoName" className="col-form-label">Upload Section logo :</label>
                                                    <input type="file" className="form-control" name="logoName" onChange={handleUploadLogo} ref={inputRef} />
                                                </div>
                                                {sectionData.logoName && (
                                                    <div style={{ marginTop: '10px' }}>
                                                        *Selected logo: {sectionData.logoName}
                                                    </div>
                                                )}

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Active Status :</label>
                                                    <input type="checkbox" name="isActive" checked={sectionData.isActive} style={{
                                                        marginLeft: '20px', width: '18px',
                                                        height: '16px',
                                                        accentColor: 'green', marginTop: '20px',
                                                    }} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => { addSection(); inputRef.current.value = '' }}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { /*setSectionList([]);*/ setEditId(''); setSectionData(initialFormState); inputRef.current.value = '' }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSection} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Section Id
                                                                            <SortIcon sortState={sectionIdSort} setSortState={setSectionIdSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionName"} />
                                                                        </th>
                                                                        <th scope="col">Address</th>
                                                                        <th scope="col">
                                                                            Principal Name
                                                                            <SortIcon sortState={principleNameSort} setSortState={setPrincipleNameSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"sectionInchargeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setSectionList} setCurrPage={setCurrPage} sortingPath={"email"} />
                                                                        </th>
                                                                        <th scope="col">Website</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((section, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{section.boardMasterDetails?.boardName}</td>
                                                                                        <td>{section.streamOrMediumMasterDetails?.streamName}</td>
                                                                                        <td>{section.sectionId}</td>
                                                                                        <td>{section.sectionName}</td>
                                                                                        <td>{section.address}</td>
                                                                                        <td>{section.sectionInchargeName}</td>
                                                                                        <td>{section.email}</td>
                                                                                        <td>{section.website}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }} onClick={() => {
                                                                                                setSectionData({
                                                                                                    instituteMasterId: instituteMasterId,
                                                                                                    boardMasterId: section.boardMasterId,
                                                                                                    streamOrMediumMasterId: section.streamOrMediumMasterId,
                                                                                                    sectionName: section.sectionName,
                                                                                                    address: section.address,
                                                                                                    state: section.state,
                                                                                                    district: section.district,
                                                                                                    city: section.city,
                                                                                                    pincode: section.pincode,
                                                                                                    sectionInchargeName: section.sectionInchargeName,
                                                                                                    contactNumber: section.contactNumber,
                                                                                                    contactNumber2: section.contactNumber2,
                                                                                                    email: section.email,
                                                                                                    website: section.website,
                                                                                                    logoName: section.logoName,
                                                                                                    logoPath: section.logoPath,
                                                                                                    allottedStudents: section.allottedStudents,
                                                                                                });
                                                                                                setEditId(section.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === section.id} onClick={() => deleteSection(section.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Sections Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={sectionList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionMaster;